import { useEffect, useState } from 'react';
import { ReactElement } from 'react';
import { Icon } from '@/common/components/Icons/Icon';
import { Image } from 'expo-image';
import { styles } from './IconBadgeFile.styles';

export function IconBadgeFile({
  fileUrl,
  icon,
}: {
  fileUrl?: string;
  icon?: ReactElement;
}) {
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoadError(false);
  }, [fileUrl]);

  if (loadError) {
    return <Icon icon="file-pdf" />;
  }

  if (fileUrl) {
    return (
      <Image
        source={{ uri: fileUrl }}
        className={styles.icon}
        contentFit="cover"
        transition={250}
        onError={() => {
          setLoadError(true);
        }}
      />
    );
  }

  return icon ?? <Icon icon="file" />;
}
